/*
 * @Author: wsx
 * @Date: 2022-01-12 16:26:00
 * @LastEditTime: 2022-06-15 17:16:16
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:
 */
import util from "@util/js";
class Validate {
  constructor(ruleFormRef) {
    this.ruleFormRef = ruleFormRef;
  }

  // 验证用户名包含（字母、数字、下划线） ，长度3-18
  userName = (rule, value, callback) => {
    const pattern1 = /\w/;
    const pattern2 = /\w{2,18}$/;
    if (value === "") {
      callback(new Error("请输入用户名"));
    } else if (!pattern1.test(value)) {
      callback(new Error("用户名只能包含字母、数字、下划线”"));
    } else if (!pattern2.test(value)) {
      callback(new Error("用户名长度应为3到18字符"));
    } else {
      callback();
    }
  };

  // 验证密码
  password(rule, value, callback) {
    const pattern = /^[A-Za-z]\w{6,16}$/;
    if (value === "") {
      callback(new Error("请设置密码"));
    } else if (!pattern.test(value)) {
      callback(new Error("密码格式错误(格式为6-16包含字母大小写数字)"));
    } else {
      callback();
    }
  }

  // 身份证
  iDCard(rule, value, callback) {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入身份证号"));
    } else if (!util.checkIdCard(value)) {
      callback(new Error("身份证号码格式错误"));
    } else {
      callback();
    }
  }

  // 身份证
  iDCards(rule, value, callback) {
    if (!value || value === "") {
      callback(new Error("请输入身份证号"));
    } else if (value.indexOf("*") !== -1 && value.length === 18) {
      callback();
    } else if (!util.checkIdCard(value)) {
      callback(new Error("身份证号码格式错误"));
    } else {
      callback();
    }
  }

  // 验证邮箱地址
  email(rule, value, callback) {
    if (value === "") {
      callback(new Error("请输入邮箱"));
    } else if (!util.checkEmail(value)) {
      callback(new Error("邮箱地址格式错误"));
    } else {
      callback();
    }
  }

  // 验证手机号
  tel(rule, value, callback) {
    if (!rule.required) {
      callback();
      return
    }
    if (value === "") {
      callback(new Error("请输入手机号"));
    } else if (!util.checkTel(value)) {
      callback(new Error("手机格式错误"));
    } else {
      callback();
    }
  }

  // 身份证
  tels(rule, value, callback) {
    if (!value || value === "") {
      callback(new Error("请输入手机号"));
    } else if (value.indexOf("*") !== -1 && value.length === 11) {
      callback();
    } else if (!util.checkTel(value)) {
      callback(new Error("手机格式错误"));
    } else {
      callback();
    }
  }
}
export default Validate;